import {normalizeData, onReady} from "../../../../modules/vegas/js/util";

function initCountSymbols() {
	[...document.querySelectorAll('[data-symbols-count]')].forEach(elm => {
		CountSymbols.init(elm);
	});
}

const CountSymbols = {
	init(el){
		let minlength = normalizeData(el.dataset.symbolsCount) || 0,
			container = document.getElementById(el.dataset.symbolsId),
			maxlength = normalizeData(container.getAttribute('maxlength')) || 0;

		container.addEventListener('input', () => {
			this.update(el, container, minlength, maxlength);
		});

		return this;
	},
	update(elm, container, minlength, maxlength) {
		let currentLength = maxlength - normalizeData(container.value.length);
		elm.textContent = currentLength;

		if (currentLength <= minlength) {
			elm.closest('.form-symbol').classList.remove('d-none')
		} else {
			elm.closest('.form-symbol').classList.add('d-none')
		}
	}
};

onReady(initCountSymbols);
